import {DebugMenuButton} from "./DebugMenuButton";
import {DebugDragAbleCont} from "./DebugDragAbleCont";
import {DebugSoundBar} from "./Sound/DebugSoundBar";
import {DebugPerformance} from "./Performance/DebugPerformance";
import {gsap} from "gsap";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {Helper} from "../../../core/utils/Helper";
import {BlitzKriegSound} from "../../../game/sound/BlitzKriegSound";

export class DebugDataBox extends DebugDragAbleCont {

    private tl: gsap.core.Timeline;

    private buttons: DebugMenuButton[] = [];
    private bgInfoGraphic: PIXI.Graphics;

    private bgTabGraphic: PIXI.Graphics;

    constructor() {
        super(true);
        this.init();
        this.createMenuButtons();
    }

    private get boxTabWidht(): number {
        return 180;
    }

    private get boxTabHeight(): number {
        return 120 * 3 - 20;
    }

    private get boxWidht(): number {
        return 180 * 3;
    }

    private get boxHeight(): number {
        return 640;
    }

    private init(): void {
        this.createGraphics();
    }

    private createGraphics(): void {

        this.bgInfoGraphic = this.addChild(new PIXI.Graphics());

        this.bgInfoGraphic.clear();
        this.bgInfoGraphic.lineStyle(3, 0xFFFFFF, 1);
        this.bgInfoGraphic.beginFill(0x000000, 0.75);

        this.bgInfoGraphic.drawRoundedRect(
            0,
            0,
            this.boxWidht,
            this.boxHeight, 14);
        this.bgInfoGraphic.endFill();
        this.subscribe(this.bgInfoGraphic);
        this.bgInfoGraphic.position.y = -this.boxTabHeight / 2;
        this.bgInfoGraphic.position.x = this.boxTabWidht / 2;

        this.bgInfoGraphic.alpha = 0;
        this.bgInfoGraphic.scale.x = 0;

        this.bgTabGraphic = this.addChild(new PIXI.Graphics());

        this.bgTabGraphic.clear();
        this.bgTabGraphic.lineStyle(3, 0xFFFFFF, 1);
        this.bgTabGraphic.beginFill(0x000000, 0.75);

        this.bgTabGraphic.drawRoundedRect(
            -this.boxTabWidht / 2,
            -this.boxTabHeight / 2,
            this.boxTabWidht,
            this.boxTabHeight, 14);
        this.bgTabGraphic.endFill();
        // this.bgTabGraphic.position.set(0, -(this.boxHeight - this.boxTabHeight/2))

        this.subscribe(this.bgTabGraphic);
        // this.subscribe(this);
    }

    private createMenuButtons(): void {

        this.buttons.push(this.addChild(new DebugMenuButton("Sound", this.addChild(new DebugSoundBar(BlitzKriegSound.soundPlayer)))));
        const height: number = ArrayHelper.fetchLastValue(this.buttons).height;
        // ArrayHelper.fetchLastValue(this.buttons).position.set(0, -this.boxTabHeight/2 + this.buttons.length * (height + 15) )

        // this.buttons.push(this.addChild(new DebugMenuButton("Server", this.addChild(new DebugServerData(modelData)))));
        // ArrayHelper.fetchLastValue(this.buttons).position.set(0, -this.boxTabHeight/2 + this.buttons.length * (height + 15) )

        this.buttons.push(this.addChild(new DebugMenuButton("Performance", this.addChild(new DebugPerformance()))));
        // ArrayHelper.fetchLastValue(this.buttons).position.set(0, -this.boxTabHeight/2 + this.buttons.length * (height + 15) )

        // ArrayHelper.fetchLastValue(this.buttons).position.set(160,-this.boxHeight/2)
        this.buttons.forEach((btn, index) => {
            btn.position.set(0, -this.boxTabHeight / 2 + (index + 1) * (height + 15))
            btn.setPressedCallback((v: string) => this.switchButton(v))
        })
    }

    private switchButton(name: string): void {
        this.buttons.forEach(btn => {
            if (btn.name != name) btn.disable();
        });
        this.onAnyActive();
    }

    public disableBtns(): void {
        this.switchButton("");
    }

    private onAnyActive(): void {
        const enabledButton: DebugMenuButton = this.buttons.filter(b => b.activated)[0];

        this.tl = Helper.setTimeline(this.tl, new gsap.core.Timeline());

        if (enabledButton) {
            this.tl.to(this.bgInfoGraphic, {alpha: 1, duration: 0.25}, 0)
            this.tl.to(this.bgInfoGraphic.scale, {x: 1, duration: 0.25}, 0)
        } else {
            this.tl.to(this.bgInfoGraphic, {alpha: 0, duration: 0.25}, 0)
            this.tl.to(this.bgInfoGraphic.scale, {x: 0, duration: 0.25}, 0)
        }
    }

    public onQuickCommand(value: string): void {
        const targetBtn: string = this.fetchPreDefinedQC(value);
        this.buttons.forEach(btn => {
            if (btn.name == targetBtn) btn.onInteracted();
        });
    }

    private fetchPreDefinedQC(v: string): string {
        switch (v) {
            case "I":
            case "i":
                return "Server";
            case "P":
            case "p":
                return "Performance";
            case "S":
            case "s":
                return "Sound";
            default:
                return "";
        }
    }
}
